import { ICourse } from '@/shared/ICourse';
import { MenuItem } from '@chakra-ui/react';
import { FiEdit } from 'react-icons/fi';

export const MenuItemEditCourse = (props: {
  course: ICourse;
  onUpdateCourse: (course: ICourse) => void;
}) => {
  return <MenuItem icon={<FiEdit />} onClick={() => props.onUpdateCourse(props.course)} >Edit Course...</MenuItem>
}
